import OrganizationRepository from "../domain/data/OrganizationRepository";
import Organization from "../domain/entities/Organization";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APIOrganizationRepository
  implements OrganizationRepository
{
  private client = new AwsApiClient();

  async getOrganizations(user: User): Promise<Organization[]> {
    throw new Error("Method not implemented.");
  }

  async saveOrganizations(org: Organization): Promise<Organization> {
    try {
      const response = await this.client.post(`/api/organization`, org);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getOrganization(organizationId: string): Promise<Organization> {
    try {
      const response = await this.client.get(
        `/api/organization/${organizationId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async deleteOrganization(organizationId: string): Promise<Boolean> {
    try {
      const response = await this.client.delete(
        `/api/organization/${organizationId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getOrganizationByURl(organizationUrl: string): Promise<Organization> {
    try {
      const response = await this.client.get(
        `/api/org/getbyurl?url=${organizationUrl}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
